import { apiNet } from "@cems-eco/core/src/services/api";
import { BaseMonitorBloc } from "./bloc";

export class CloudMonitorBloc extends BaseMonitorBloc {

    searchParams(log: any, equipment_id: any): string {
        const params = {
            search: {
                advanced: {
                    type: log.level,
                    equipment_id
                }
            }
        } as any;
        if (log.start_date && log.end_date) {
            params.search.between = {
                created_at: `${log.start_date},${log.end_date}`
            }
        }
        return apiNet.getUrl("/log", params);
    }

    async getCloudEquipment(id: string): Promise<string> {
        return await this.api.getEquipment(id);
    }

    

    async getCloudSite(params = {}): Promise<string> {
        return await this.api.getCloudSite(params);
    }

}

